import { API_URL } from '@/config';
import { getAccessToken } from './authStorage';
import { getValidAccessToken, refreshAccessToken } from './authRefresh';
import { notifyApiException, notifyFetchApiError } from './apiErrorToast';

function isApiRequest(input) {
  const url = typeof input === 'string' ? input : input?.url;
  return Boolean(url && url.startsWith(API_URL));
}

function isAuthEndpoint(input) {
  const url = typeof input === 'string' ? input : input?.url || '';
  return url.includes('/auth/login') || url.includes('/auth/refresh') || url.includes('/auth/logout');
}

function redirect(path) {
  if (window.location.pathname !== path) {
    window.location.href = path;
  }
}

async function buildHeaders(input, init, shouldValidateToken = false) {
  const headers = new Headers(input instanceof Request ? input.headers : undefined);
  new Headers(init?.headers || {}).forEach((value, key) => headers.set(key, value));

  const storedAccessToken = getAccessToken();
  const accessToken = shouldValidateToken
    ? await getValidAccessToken(storedAccessToken)
    : storedAccessToken;
  if (accessToken && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  return headers;
}

async function withAccessToken(input, init, accessToken) {
  const headers = await buildHeaders(input, init);
  headers.set('Authorization', `Bearer ${accessToken}`);
  return { ...init, headers };
}

export function installAuthFetch() {
  const nativeFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const shouldAttachAuth = isApiRequest(input) && !isAuthEndpoint(input);
    const requestInit = shouldAttachAuth
      ? { ...init, headers: await buildHeaders(input, init, true) }
      : init;
    let response = await nativeFetch(input, requestInit);

    if (shouldAttachAuth && response.status === 401) {
      try {
        const accessToken = await refreshAccessToken();
        response = await nativeFetch(input, await withAccessToken(input, init, accessToken));
      } catch (e) {
        notifyApiException(e, typeof input === 'string' ? input : input?.url);
        return response;
      }
    }

    if (shouldAttachAuth && !response.ok) {
      await notifyFetchApiError(response);
    }

    if (shouldAttachAuth && response.status === 403) {
      redirect('/forbidden');
    }

    return response;
  };
}
